var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.4364 13.0001L25.7025 1.73384C26.0992 1.33718 26.0992 0.69409 25.7025 0.297489C25.3059 -0.0991123 24.6628 -0.0991631 24.2662 0.297489L13 11.5637L1.73383 0.297489C1.33718 -0.0991631 0.694089 -0.0991631 0.297488 0.297489C-0.099112 0.694141 -0.0991628 1.33723 0.297488 1.73384L11.5636 13L0.297488 24.2662C-0.0991628 24.6629 -0.0991628 25.306 0.297488 25.7026C0.495789 25.9009 0.755737 26 1.01569 26C1.27563 26 1.53553 25.9009 1.73388 25.7026L13 14.4364L24.2661 25.7026C24.4644 25.9009 24.7244 26 24.9843 26C25.2443 26 25.5042 25.9009 25.7025 25.7026C26.0992 25.3059 26.0992 24.6628 25.7025 24.2662L14.4364 13.0001Z",
    fill: "#363838"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.6caa95e3dfec41d9fd4e693b83ff8a3b.svg";
export { ForwardRef as ReactComponent };